export default __webpack_public_path__ + "static/media/navbar-visit-history-dark.a258c4e2.svg";